import { createAction } from '@/utils/actions'
import * as modalActionTypes from './constants'

export const modalShow = createAction(modalActionTypes.MODAL_SHOW)
export const modalDismiss = createAction(modalActionTypes.MODAL_DISMISS)
